import { useState } from "react";
import style from "./customcheckbox.module.css";

export default function CustomCheckbox({ label }) {
  const [checked, setChecked] = useState(false);

  return (
    <label className={style.checkboxLabel}>
      <input
        type="checkbox"
        checked={checked}
        onChange={() => setChecked(!checked)}
      />
      <span className={style.customCheckbox}></span>
      <p>{label}</p>
    </label>
  );
}
